import { render, staticRenderFns } from "./RegisterPhoneVerify.vue?vue&type=template&id=48b57429&scoped=true&"
import script from "./RegisterPhoneVerify.vue?vue&type=script&lang=js&"
export * from "./RegisterPhoneVerify.vue?vue&type=script&lang=js&"
import style0 from "../../less/login.less?vue&type=style&index=0&id=48b57429&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b57429",
  null
  
)

export default component.exports